export default (error: string) => {
  switch (error) {
    case 'ERROR_CODE_INCORRECT':
      return 'The login token is incorrect';

    default:
      return 'Unknown error';
  }
};
